<template>
  <div class="alert" v-on:click="$emit('close')">
    <div class="inner">
      <svg
        width="42"
        height="46"
        viewBox="0 0 42 46"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="8.95783"
          y="6.47229"
          width="32.3187"
          height="38.8054"
          rx="4.27771"
          stroke="#3B7CF3"
          stroke-width="1.44458"
        />
        <rect width="33.3089" height="39.0037" rx="5" fill="#3B7CF3" />
      </svg>
      <p>클립보드에 링크가 복사되었습니다.</p>     
    </div>
  </div>
</template>

<style lang="scss" scoped>
.alert {
  position: fixed;
  bottom: var(--app-gutter-size);
  right: var(--app-gutter-size);
  max-width: calc(100% - var(--app-gutter-size) * 2);
  width: 440px;
  height: 60px;
  background: #EEF4FF;
  z-index: 99;
  box-shadow: 0px 16px 26px rgba(24, 26, 25, 0.08), 0 -1px 3px 6px rgba(24, 26, 25, 0.015);
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #3B7CF3;
}

.inner {
  width: 100%;
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 18px 0 24px;
}

svg {
  display: block;
  height: 18px;
  width: auto;
  margin: 0 14px 0 0;
}

p {
  font-size: 16px;
  font-weight: 500;
  color: #3B7CF3;
}

button {
  display: block;
  width: auto;
  height: 36px;
  border-radius: 2px;
  background-color: #181A19;
  color: white;
  font-size: 13px;
  padding: 0 24px;
  border: 0;
  outline: 0;
  margin-left: auto;
}
</style>